export const DEFAULT_ENV = "production";
export const PROXY_ENV = "proxy";

// Environment detection patterns - order matters (most specific first)
const ENV_PATTERNS = [
  { pattern: 'localhost', env: PROXY_ENV },
  { pattern: 'dev1', env: 'development' },
  { pattern: 'dev2', env: 'development2' },
  { pattern: 'dev3', env: 'development3' },
  { pattern: 'sandbox2', env: 'sandbox2' },
  { pattern: 'sandbox', env: 'sandbox' },
  { pattern: 'qa1', env: 'qa1' },
  { pattern: 'qa2', env: 'qa2' },
  { pattern: 'imp1', env: 'imp1' },
  { pattern: 'uat1', env: 'uat1' },
  { pattern: 'perf', env: 'perf' },
  { pattern: 'training', env: 'training' },
  { pattern: 'conv', env: 'conv' },
  { pattern: 'dr', env: 'dr' },
  { pattern: 'payrailzprod', env: 'production' },
];

// Auto-detect environment from current hostname
export const detectEnvironment = () => {
  if (typeof window === 'undefined') return PROXY_ENV;
  
  const hostname = window.location.hostname.toLowerCase();
  
  // Find first matching pattern
  const match = ENV_PATTERNS.find(({ pattern }) => hostname.includes(pattern));
  
  return match ? match.env : DEFAULT_ENV;
};

export const environments = {
  sandbox: {
    host: "https://sandboxiav.payrailztest.com",
  },
  sandbox2: {
    host: "https://sandbox2iav.payrailztest.com",
  },
  development: {
    host: "https://dev1iav.payrailzdev.com",
  },
  development2: {
    host: "https://dev2iav.payrailzdev.com",
  },
  development3: {
    host: "https://dev3iav.payrailzdev.com",
  },
  qa1: {
    host: "https://qa1iav.payrailzdev.com",
  },
  qa2: {
    host: "https://qa2iav.payrailzdev.com",
  },
  imp1: {
    host: "https://imp1iav.payrailztest.com",
  },
  perf: {
    host: "https://perfiav.payrailzdev.com",
  },
  training: {
    host: "https://trainingiav.payrailztest.com",
  },
  conv: {
    host: "https://conviav.payrailztest.com",
  },
  dr: {
    host: "https://driav.payrailzdr.com",
  },
  uat1: {
    host: "https://uat1iav.payrailztest.com",
  },
  local: {
    host: "http://localhost:5002",
  },
  localsecure: {
    host: "https://localhost",
  },
  production: {
    host: "https://iav.payrailzprod.com",
  },
  proxy: {
    host: "", // http://localhost:3003/
  },
};
